import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Descargás el PDF',
    desc: 'Lo tenés en tu celu o compu al instante.'
  }, {
    num: '2',
    title: 'Aplicás el Protocolo',
    desc: 'Mañana mismo hacés el ejercicio de 15 minutos antes de irte.'
  }, {
    num: '3',
    title: 'Monitoreás los cambios',
    desc: 'Vas a notar que tu perro está más "desenchufado" y tranquilo desde el primer día.'
  }];
  return <section className="py-12 sm:py-24 px-5 sm:px-8 max-w-4xl mx-auto" data-id="element-119">
      <FadeIn data-id="element-120">
        <h2 className="text-2xl sm:text-4xl text-depto-brown mb-8 sm:mb-16 text-center" data-id="element-121">
          Cómo funciona:
        </h2>
      </FadeIn>

      <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-depto-amber/30 before:to-transparent" data-id="element-122">
        {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.2} data-id="element-123">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-124">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-depto-amber text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-125">
                {step.num}
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-sm border border-depto-brown/5 ml-6 md:ml-0" data-id="element-126">
                <h3 className="font-bold text-depto-brown text-xl mb-2" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-depto-brown/70" data-id="element-128">{step.desc}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}